import { gql } from '@apollo/client'
import { getCustomizationsQuery } from '../utils/query'

export const getStorefrontConfig = gql`
  query getStoreFront($name: String!, $configId: String!) {
    storefront(name: $name) {
      id
      name
      currency
      currencyPrefix
      currencyFormat
      customer
      config
      enabledOrderNote
      enabledCustomCart
      enabledProductDetail
      logo
      minAmount
      maxAmount
    }
    orderConfig(id: $configId) {
      id
      ttl
      source
      channelName
      botSlug
      state
      userID
      channelID
      metadata
      status
    }
  }
`

export const searchProductsByNameQuery = gql`
  query searchProduct($name: String!, $configId: ID!, $product: String) {
    searchProduct(storefront: { name: $name }, orderConfigID: $configId, product: { query: $product }) {
      id
      name
      enabledPrice
      ranking
      productsPriced {
        id
        name
        sku
        description
        category
        ranking
        imageURL
        clientType
        showDescription
        price
        type
        packType
        unitsBox
        sizeDescription
        tags
      }
    }
  }
`

export const getCatalog = gql`
  query catalog($name: String!, $configId: String!) {
    catalog(storefrontName: $name, orderConfigID: $configId, collectionOrder: ASC, productOrder: ASC) {
      id
      name
      enabledPrice
      ranking
      productsPriced {
        id
        name
        sku
        description
        category
        ranking
        imageURL
        clientType
        showDescription
        price
        type
        packType
        unitsBox
        sizeDescription
        tags
        metadata
      }
    }
  }
`

export const searchProductsByIdQuery = (depth = 2) => {
  const customizationsQuery = getCustomizationsQuery(depth)

  return gql`
    fragment ProductFields on Product {
      id
      name
      sku
      description
      category
      ranking
      imageURL
      clientType
      showDescription
      price
      type
      ${customizationsQuery}
    }

    fragment ProductCustomizationFields on Product {
      id
      name
      sku
      description
      category
      ranking
      imageURL
      clientType
      price
      showDescription
      size
      type
      minItems
      maxItems
      packType
      unitsBox
      sizeDescription
      tags
      conditionalAppearance {
        condition
        itemName
      }
    }
    query productsPricedPerCollection($name: String!, $configId: String!, $productId: String) {
      productsPricedPerCollection(
        name: $name
        orderConfigID: $configId
        productFilterID: $productId
        collectionOrder: "ASC"
        rankingOrder: "ASC"
      ) {
        id
        name
        enabledPrice
        productsPriced {
          ...ProductFields
        }
      }
    }
  `
}

export const getProductsByListOfIDs = gql`
  query productsPricedPerCollection($name: String!, $configId: String!, $productIds: [String]) {
    productsPricedPerCollection(
      name: $name
      orderConfigID: $configId
      productFilterIDs: $productIds
      collectionOrder: "ASC"
      rankingOrder: "ASC"
    ) {
      id
      name
      enabledPrice
      productsPriced {
        id
        name
        sku
        description
        category
        ranking
        imageURL
        clientType
        showDescription
        price
        type
        packType
        unitsBox
        sizeDescription
        tags
        customizations {
          id
          name
          sku
          description
          category
          ranking
          imageURL
          clientType
          price
          showDescription
          size
          type
          minItems
          maxItems
          packType
          unitsBox
          sizeDescription
          tags
          conditionalAppearance {
            condition
            itemName
          }
          customizations {
            id
            name
            sku
            description
            category
            ranking
            imageURL
            clientType
            price
            showDescription
            size
            type
            minItems
            maxItems
            packType
            unitsBox
            sizeDescription
            tags
            conditionalAppearance {
              condition
              itemName
            }
          }
        }
      }
    }
  }
`

export const customCart = gql`
  query customCart($storefrontID: String!, $orderConfigID: String!, $cart: [CartInputType]) {
    customCart(storefrontID: $storefrontID, orderConfigID: $orderConfigID, cart: $cart) {
      id
      name
      sku
      description
      category
      ranking
      imageURL
      clientType
      showDescription
      price
      type
      cartId
      quantity
      totalPrice
      customizations {
        id
        name
        sku
        description
        category
        ranking
        imageURL
        clientType
        price
        showDescription
        size
        type
        minItems
        maxItems
        cartId
        quantity
        totalPrice
        packType
        unitsBox
        sizeDescription
        tags
        conditionalAppearance {
          condition
          itemName
        }
        customizations {
          id
          name
          sku
          description
          category
          ranking
          imageURL
          clientType
          price
          showDescription
          size
          type
          minItems
          maxItems
          cartId
          quantity
          totalPrice
          packType
          unitsBox
          sizeDescription
          tags
          conditionalAppearance {
            condition
            itemName
          }
        }
      }
    }
  }
`

export const createOrderMutation = gql`
  mutation createOrder($order: OrderInputTypes, $configId: ID!) {
    createOrder(data: $order, orderConfigID: $configId) {
      storefrontID
      userID
      status
    }
  }
`

export const updateOrderConfig = gql`
  mutation updateOrderConfig($id: String!, $data: OrderConfigTypeInput!) {
    updateOrderConfig(id: $id, data: $data) {
      id
      metadata
    }
  }
`
